import React from 'react';
import { color as Color } from '@moda/tokens';

interface Props {
  selected: boolean;
}

export const LooksThumbnailViewSwitcher: React.FC<Props> = ({ selected }) => {
  const color = (selected ? Color('ink') : Color('fog')) ?? undefined;

  return (
    <svg width="37" height="24" viewBox="0 0 37 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="5" height="20" fill={color} />
      <rect x="9" y="2" width="5" height="20" fill={color} />
      <rect x="16" y="2" width="5" height="20" fill={color} />
      <rect x="23" y="2" width="5" height="20" fill={color} />
      <rect x="30" y="2" width="5" height="20" fill={color} />
      <rect x="0.5" y="0.5" width="36" height="23" stroke={color} />
    </svg>
  );
};
